import { z } from "zod";

import { machineTrackMaterialSchema, machineTrackSchema } from "./machine-track";

export const machineCorrugateTrackMaterialSchema = machineTrackMaterialSchema.extend({
	width: z.number(),
	thickness: z.number(),
	quality: z.number(),
});

export const machineCorrugateTrackSchema = machineTrackSchema.extend({
	assignedMaterial: machineCorrugateTrackMaterialSchema,
});

export const machineCorrugateTrackWithOffsetSchema = machineCorrugateTrackSchema.extend({
	trackOffset: z.number().catch(0),
});

export const machineCorrugateTrackWithToleranceSchema = machineCorrugateTrackSchema.extend({
	corrugateTolerance: z.number(),
	width: z.number(),
});

export type MachineCorrugateTrack = z.infer<typeof machineCorrugateTrackSchema>;
export type MachineCorrugateTrackWithOffset = z.infer<typeof machineCorrugateTrackWithOffsetSchema>;
export type MachineCorrugateTrackWithTolerance = z.infer<typeof machineCorrugateTrackWithToleranceSchema>;

export type MachineCorrugateTrackMaterial = z.infer<typeof machineCorrugateTrackMaterialSchema>;
